import { render } from "./RefundGoods.vue?vue&type=template&id=4f5671d6"
import script from "./RefundGoods.vue?vue&type=script&lang=js"
export * from "./RefundGoods.vue?vue&type=script&lang=js"

import "./RefundGoods.vue?vue&type=style&index=0&id=4f5671d6&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__